import { render, staticRenderFns } from "./BlogThreeColumn.vue?vue&type=template&id=612861c0&"
import script from "./BlogThreeColumn.vue?vue&type=script&lang=js&"
export * from "./BlogThreeColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports